fragment accordionFields on accordion_MatrixField {
    ... on accordionTab_Entry {
        title: accordionTitle
        content: accordionContent
    }
}
